module.exports = __webpack_public_path__ + "img/465.26c23b29.jpg";